import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { Table } from 'components/molecules/Table';
import { FormRadioGroup } from 'components/molecules/FormRadioGroup';
import { formatDate, getFullYearsSince, leftDays } from 'utils/date';
import { CardList, emptyFieldHolder } from 'components/molecules/CardList';
import React, { useEffect, useMemo, useState } from 'react';
import { useLegalEntities } from 'pages/LegalEntitiesPage/hooks';
import { Loader } from 'components/atoms/Loader';
import { useGlobalProperty } from 'models/globalPropertyContext';
import { useTranslations } from 'hooks/useTranslations';
import { ERouteLinks } from 'models/route';
import { ELegalEntityTypes, LETypes } from 'constants/LegalEntityTypes';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { LEAccordionNames } from 'components/organisms/LEAccordions';
import { useScroll } from 'hooks/useScroll';
import { useForm } from 'react-hook-form';
import { Chips } from 'components/atoms/Chips';
import { Box } from '@mui/system';
import { useDictionary } from 'models/dictionaryContext';
import { useAlert } from 'models/alertContext';
import { ActionTypes } from 'state/actions/alert';
import { IExtendedLegalEntityLicenceDetails } from 'models/legalEntity';
import { StyledPageTitle } from 'theme/styles';
import { useQuery } from 'hooks/useQuery';
import { IDictionary } from 'models/dictionary';
import { DetailsTemplate } from 'components/templates/DetailsTemplate';
import { getLicenceHistoryDetails } from 'requests/licence';
import { StyledSectionTypography } from 'components/organisms/LegalEntityDetails/styles';
import { mergeDictionaries } from 'components/organisms/Dictionaries';
import { EButtonSizes, EButtonStyleVariant, EButtonVariants } from 'constants/Buttons';
import Button from 'components/atoms/Button';
import { EIconTypes } from 'constants/Icons';
import { useThemeBreakpoint } from 'hooks/useThemeBreakpoint';
import {
  EDictionaryPrefixTypesUniqueId,
  findInDictionaryList,
  parseDictionary,
} from 'helpers/dictionary';
import { formatAddress } from 'utils/legalAddress';
import { colors } from 'theme/colors';
import { Alert, EAlertVariants } from 'components/atoms/Alert';
import { ELicenceHistoryActions, ELicenceStatusIds } from 'pages/LegalEntitiesPage/helpers';
import LicenceStore from 'state/LicenceStore';
import { usePermission } from 'hooks/usePermission';
import { EPermission } from 'models/permissions';
import { EmptyPhotoContainer } from 'components/organisms/EmptyPhotoContainer';
import { priceFormat } from 'helpers/price';
import { useAccount } from 'pages/AccountPage/hooks';
import { Accordion } from 'components/molecules/Accordion';
import { getHtmlText } from 'components/organisms/HtmlSlate';
import { ELegalVisibility } from 'constants/LegalVisibility';
import { getGlobalPropertyByKey } from 'requests/globalProperty';
import { FormModal } from 'components/molecules/Modal';
import { useWeaponLicenceModule } from 'hooks/useWeaponLicenceModule';
import { HistoryTableCard } from './HistoryTableCard';
import { PrintoutHistoryTableCard } from './PrintoutHistoryTableCard';
import {
  DetailsContainer,
  DetailsContainerWhite,
  StyledButtonsContainer,
  StyledDivider,
  StyledHeaderContainer,
  StyledOwnerDetail,
  StyledPhoto,
  SubsectionHeader,
} from './styles';
import {
  attachmentsTableColumns,
  createSafeStorageAddressList,
  getDictionaryValue,
  getLicenceStatusChipVariant,
  getOwnerDisplayName,
  getPaymentStatusChipVariant,
  historyTableColumns,
  isLicenceActive,
  isLicenceScheduled,
  isLicenceSuspended,
  mapAttachmentsToDataSource,
  mapHistoryToDataSource,
  mapPrintoutsHistoryToDataSource,
  mapWeaponToDataSource,
  printoutHistoryTableColumns,
  weaponTableColumns,
} from './helpers';
import { AttachmentTableCard } from './AttachmentTableCard';
import { WeaponTableCard } from './WeaponTableCard';
import { LicenceActionModal } from './LicenceActionModal';
import { LicenceHistoryDetailsModal } from './LicenceHistoryDetailsModal';
import { notApplicableFieldHolder } from '../../LicencesPage/helpers';
import { useConfigurationLicence } from 'pages/LicenceConfigurationPage/hooks';
import { usePrintLicence } from 'pages/LicenceDetailsPage/hooks';
import { getGalleryPreview } from 'requests/gallery';
import { ESize } from 'models/galery';
import { ILegalEntityCustomField } from 'components/organisms/LegalEntityDetails';
import { ECustomFieldType } from 'models/customField';
import { useLang } from 'models/langContext';
import { EFieldsOptional } from 'pages/SystemSettingsPage/SystemFieldsConfigurationPage/helpers';
import { useSystemFieldsConfiguration } from 'pages/SystemSettingsPage/SystemFieldsConfigurationPage/hooks';
import { useCase } from 'pages/CaseManagementPage/CasesPage/hooks';
import {
  getLicenceCaseRenewStatusText,
  getLicenceCaseVaryStatusText,
} from 'pages/CaseManagementPage/CasesPage/helpers';
import { ECaseRenewalStatus, ECaseVariationStatus } from 'models/cases';

enum ELicenceHistoryDisplay {
  LICENCE = 'licenceHistory',
  PRINTOUT = 'printoutHistory',
}

const LegalEntityViewLicencePage = () => {
  const { pathname } = useLocation();
  const { isDesktop } = useThemeBreakpoint();
  const navigate = useNavigate();
  const query = useQuery();
  const { selectedLanguage, defaultLanguage } = useLang();
  const { id = '', licenceId = '' } = useParams<{ id: string; licenceId: string }>();
  const [type, setType] = useState<string | null>();
  const [isFromLE, setIsFromLE] = useState<boolean>();
  const [breadcrumbsForChildren, setBreadcrumbsForChildren] = useState<any>();
  const [breadcrumbsForHeader, setBreadcrumbsForHeader] = useState<any>();
  const { account, getSelfAccountData } = useAccount();
  const [leftDaysNotify, setLeftDaysNotify] = useState<number>(0);

  const [isLegalEntityLicenceLoading, setIsLegalEntityLicenceLoading] =
    useState<boolean>(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState<boolean>(false);
  const [isRevokeModalOpen, setIsRevokeModalOpen] = useState<boolean>(false);
  const [isSuspendModalOpen, setIsSuspendModalOpen] = useState<boolean>(false);
  const [isSurrenderModalOpen, setIsSurrenderModalOpen] = useState<boolean>(false);
  const [isReactivateModalOpen, setIsReactivateModalOpen] = useState<boolean>(false);
  const [isPrintLicenceModalOpen, setIsPrintLicenceModalOpen] = useState<boolean>(false);
  const [isRenewModalOpen, setIsRenewModalOpen] = useState<boolean>(false);
  const [isVaryModalOpen, setIsVaryModalOpen] = useState<boolean>(false);
  const [isHistoryDetailsModalOpen, setIsHistoryDetailsModalOpen] = useState<boolean>(false);
  const [showDetailsModalOpen, setShowDetailsModalOpen] = useState<boolean>(false);
  const [detailsReasonModal, setDetailsReasonModal] = useState<{
    title: string;
    externalReason: string;
    internalReason: string;
  } | null>({ title: '', externalReason: '', internalReason: '' });
  const [legalEntityPhoto, setLegalEntityPhoto] = useState<string | null>(null);
  const [historyDetailsData, setHistoryDetailsData] = useState<any>(null);
  const [latestMeaningfullActionPrice, setlatestMeaningfullActionPrice] = useState<
    string | undefined
  >(undefined);
  const [latestMeaningfullAction, setLatestMeaningfullAction] = useState<
    ELicenceHistoryActions | undefined
  >(undefined);
  const [selectedReasons, setSelectedReasons] = useState<any[]>([]);
  const { shortDateFormat, longDateFormat, getProperties, unit, currency } =
    useGlobalProperty();
  const { t, loadingT } = useTranslations();
  const [licenceAuthorityMatches, setLicenceAuthorityMatches] = useState(false);
  const [prefixForLE, setPrefixForLE] = useState<string>();
  const [legalEntity, setLegalEntity] = useState<any>();
  const { elRef } = useScroll();
  const { hasPermissions } = usePermission();
  const { hasWeaponLicenceModule } = useWeaponLicenceModule();
  const { getLegalEntityLicenceAuthoritiesData, legalEntityLicenceAuthorities } =
    useLegalEntities();
  const { getFieldsOptional, hiddenFieldsName } = useSystemFieldsConfiguration();
  const {
    setValue,
    control,
    formState: { errors },
  } = useForm<Record<string, any>>({
    defaultValues: { historyDisplay: ELicenceHistoryDisplay.LICENCE },
  });
  const [historyDisplay, setHistoryDisplay] = useState<ELicenceHistoryDisplay>(
    ELicenceHistoryDisplay.LICENCE,
  );
  const { canPrintLicence, handleEnqueueLicencePrint, historyPrintouts } =
    usePrintLicence(licenceId);

  const {
    getLegalEntityLicenceDetailsData,
    legalEntityLicenceDetails,
    getLicenceAttachmentsData,
    licenceAttachments,
    getLicenceHistoryData,
    licenceHistory,
    getLicenceAttachmentFile,
    getLicenceWeaponData,
    licenceWeapon,
    handleRevokeWeaponLicence,
    handleSuspendWeaponLicence,
    handleSurrenderWeaponLicence,
    handleReactivateWeaponLicence,
    handleCancelWeaponLicence,
    licenceMismatchingLegalEntity,
    getLicenceMismatchingLegalEntityData,
    licenceHasSuspendedParent,
    getLicenceHasSuspendedParentData,
  } = useLegalEntities();
  const {
    weaponLicenceStatus,
    weaponLicencePaymentStatus,
    weaponLicencingAuthority,
    gender,
    weaponLicenceGoodReason,
    country,
    organisationCategory,
    organisationCivilianType,
    organisationPoliceType,
    organisationMilitaryType,
    organisationStateType,
    identificationDocumentType,
    civilianPrefix,
    weaponLicenceCompetency,
    region,
    weaponLicenceCategory,
    attachmentDocumentTypeData,
    weaponLicenceCondition,
    nationality,
    state,
    firearmType,
    make,
    model,
    caliber,
    firearmAction,
    getWeaponLicenceStatus,
    getWeaponLicenceHistoryAction,
    getWeaponLicencePaymentStatus,
    getWeaponLicencingAuthority,
    getGender,
    getLegalType,
    getWeaponLicenceGoodReason,
    getCountry,
    getOrganisationCategory,
    getOrganisationCivilianType,
    getOrganisationMilitaryType,
    getOrganisationPoliceType,
    getOrganisationStateType,
    getIdentificationDocumentType,
    getCivilianPrefix,
    getWeaponLicenceCompetency,
    getRegion,
    getWeaponLicenceCategory,
    getAttachmentDocumentTypeData,
    getWeaponLicenceCondition,
    getNationality,
    getState,
    getFirearmType,
    getMake,
    getModel,
    getCaliber,
    getFirearmAction,
    weaponLicencePrintType,
    getWeaponLicencePrintType,
  } = useDictionary();

  const {
    getCaseRenewalStatus,
    caseRenewalStatus,
    getCaseVariationStatus,
    caseVariationStatus,
  } = useCase();

  const { getLicence, licence } = useConfigurationLicence();

  const { samePageAlert, nextPageAlert, clearAlert } = useAlert();

  useEffect(() => {
    (async function getGlobalPropertyDataInit() {
      const days = await getGlobalPropertyByKey('licence_expiration_notification_days_before');
      if (days) {
        setLeftDaysNotify(Number(days.value));
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (licenceId && hasPermissions(EPermission.ADD_CASES)) {
      getCaseRenewalStatus(licenceId);
      getCaseVariationStatus(licenceId);
    }
  }, [licenceId]);

  useEffect(() => {
    if (!weaponLicencePrintType) {
      getWeaponLicencePrintType();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const typedLicenceDetails =
    legalEntityLicenceDetails as unknown as IExtendedLegalEntityLicenceDetails | null;

  const handleOpenHistoryDetailsModal = async (historyUniqueId: string) => {
    setIsHistoryDetailsModalOpen(true);

    try {
      const response = await getLicenceHistoryDetails(historyUniqueId);
      setHistoryDetailsData(response);
    } catch (error) {
      console.error('Error fetching history details:', error);
    }
  };
  const handleShowDetailsModal = (
    title: string,
    externalReason: string,
    internalReason: string,
  ) => {
    setShowDetailsModalOpen(true);
    setDetailsReasonModal({ title, externalReason, internalReason });
  };

  const handleCloseHistoryDetailsModal = () => {
    setIsHistoryDetailsModalOpen(false);
    setHistoryDetailsData(null);
  };

  useEffect(() => {
    getProperties();
    getSelfAccountData();
    getFieldsOptional();
    setType(query.get('type'));
  }, []);

  useEffect(() => {
    if (typedLicenceDetails && !type) {
      const typeName =
        typedLicenceDetails?.legal?.type === LETypes.individual
          ? ELegalEntityTypes.individual
          : ELegalEntityTypes.organisation;
      setType(typeName);
    }
  }, [typedLicenceDetails]);

  const expand = query.get('expand');

  useEffect(() => {
    getWeaponLicenceStatus();
    getWeaponLicenceHistoryAction();
    getWeaponLicencePaymentStatus();
    getWeaponLicencingAuthority();
    getGender();
    getLegalType();
    getWeaponLicenceGoodReason();
    getCountry();
    getOrganisationCategory();
    getOrganisationCivilianType();
    getOrganisationMilitaryType();
    getOrganisationPoliceType();
    getOrganisationStateType();
    getIdentificationDocumentType();
    getCivilianPrefix();
    getWeaponLicenceCompetency();
    getRegion();
    getWeaponLicenceCategory();
    getAttachmentDocumentTypeData();
    getWeaponLicenceCondition();
    getNationality();
    getState();
    getFirearmType();
    getMake();
    getModel();
    getCaliber();
    getFirearmAction();
  }, []);

  useEffect(() => {
    (async function getLegalEntityLicence() {
      if (licenceId) {
        setIsLegalEntityLicenceLoading(true);
        await getLegalEntityLicenceDetailsData(licenceId);

        await getLicenceAttachmentsData(licenceId);
        await getLicenceHistoryData(licenceId);
        await getLicenceWeaponData(licenceId);
        await getLicenceMismatchingLegalEntityData(licenceId);

        setIsLegalEntityLicenceLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [licenceId]);

  useEffect(() => {
    (async () => {
      if (typedLicenceDetails?.general.statusUniqueId === ELicenceStatusIds.SUSPENDED) {
        await getLicenceHasSuspendedParentData(licenceId);
      }
    })();
  }, [typedLicenceDetails?.general.statusUniqueId]);

  const weaponLicenceTemplateId = useMemo(
    () => legalEntityLicenceDetails?.weaponLicenceTemplateUniqueId,
    [legalEntityLicenceDetails?.weaponLicenceTemplateUniqueId],
  );

  useEffect(() => {
    if (
      legalEntityLicenceDetails &&
      legalEntityLicenceDetails.galleryEntryUniqueId &&
      type === ELegalEntityTypes.individual &&
      !legalEntityPhoto
    ) {
      (async function getLegalEntityPhotoInit() {
        const photoId = legalEntityLicenceDetails.galleryEntryUniqueId;
        const photo = await getGalleryPreview(photoId, ESize.THUMBNAIL);
        setLegalEntityPhoto(photo);
      })();
    }
  }, [legalEntity, type]);

  useEffect(() => {
    (async function getDataInit() {
      if (weaponLicenceTemplateId) {
        await getLicence(weaponLicenceTemplateId);
      }
    })();
  }, [weaponLicenceTemplateId]);

  useEffect(() => {
    const filteredHistoryActions = licenceHistory?.filter(
      (it) =>
        ![
          ELicenceHistoryActions.UPDATE_PAYMENT_STATUS,
          ELicenceHistoryActions.SCHEDULED_LICENCE_RENOVATION,
        ].includes(it.historyStatus as ELicenceHistoryActions),
    );

    const latestFilteredAction =
      filteredHistoryActions && filteredHistoryActions.length > 0
        ? filteredHistoryActions[0]
        : null;

    if (filteredHistoryActions && filteredHistoryActions.length > 0) {
      setlatestMeaningfullActionPrice(latestFilteredAction?.fee);
      setLatestMeaningfullAction(
        latestFilteredAction?.historyStatus as ELicenceHistoryActions,
      );
    }
  }, [licenceHistory]);

  useEffect(() => {
    (async () => {
      if (typedLicenceDetails?.owner.legalUniqueId) {
        await getLegalEntityLicenceAuthoritiesData(typedLicenceDetails?.owner.legalUniqueId);
      }
    })();
  }, [typedLicenceDetails?.owner.legalUniqueId]);

  useEffect(() => {
    if (legalEntityLicenceAuthorities) {
      if (
        account?.licenceAuthorityIds.includes(
          legalEntityLicenceAuthorities.primaryLicenceAuthorityUniqueId,
        ) ||
        account?.licenceAuthorityIds.includes(
          legalEntityLicenceAuthorities.secondaryLicenceAuthorityUniqueId,
        )
      ) {
        setLicenceAuthorityMatches(true);
      } else {
        setLicenceAuthorityMatches(false);
      }
    }
  }, [legalEntityLicenceAuthorities, account?.licenceAuthorityIds]);

  useEffect(() => {
    if (typedLicenceDetails?.conditions?.safeStorageDescription) {
      setValue(
        'safeStorageDescription',
        typedLicenceDetails.conditions.safeStorageDescription,
      );
    }
    if (typedLicenceDetails?.conditions?.additionalConditions) {
      setValue('additionalConditions', typedLicenceDetails.conditions.additionalConditions);
    }
    if (typedLicenceDetails?.additionalInformation) {
      setValue('additionalInformation', typedLicenceDetails.additionalInformation);
    }
  }, [typedLicenceDetails, setValue]);

  useEffect(() => {
    if (civilianPrefix?.length && typedLicenceDetails) {
      const prefix = civilianPrefix?.find(
        (item: IDictionary) =>
          item?.uniqueId === typedLicenceDetails?.owner?.individual?.prefixValueUniqueId,
      )?.name;
      setPrefixForLE(prefix ?? '');
    } else {
      setPrefixForLE('');
    }
  }, [civilianPrefix, typedLicenceDetails]);

  useEffect(() => {
    if (!typedLicenceDetails) {
      setLegalEntity(undefined);
    } else if (typedLicenceDetails && typedLicenceDetails?.owner?.legalType === 'INDIVIDUAL') {
      setLegalEntity({
        uniqueId: typedLicenceDetails?.owner.legalUniqueId,
        ...typedLicenceDetails?.owner,
        ...typedLicenceDetails?.owner?.individual,
        prefixGroupUniqueId: typedLicenceDetails?.legal?.prefixGroupUniqueId,
      });
    } else if (
      typedLicenceDetails &&
      typedLicenceDetails?.owner?.legalType === 'ORGANIZATION'
    ) {
      setLegalEntity({
        ...typedLicenceDetails?.owner,
        ...typedLicenceDetails?.owner?.organisation,
      });
    }
  }, [typedLicenceDetails]);

  useEffect(
    () => () => {
      clearAlert(ActionTypes.CLEAR_NEXT_PAGE_ALERT);
      clearAlert(ActionTypes.CLEAR_SAME_PAGE_ALERT);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useEffect(() => {
    const goodReasonIds = typedLicenceDetails?.conditions?.goodReasonUniqueIds;
    if (!goodReasonIds || !Array.isArray(goodReasonIds) || goodReasonIds.length === 0) {
      setSelectedReasons([]);
    } else {
      const availableReasons = weaponLicenceGoodReason || [];
      setSelectedReasons(
        availableReasons.filter((reason) => goodReasonIds.includes(String(reason.uniqueId))),
      );
    }
  }, [typedLicenceDetails]);

  const leViewLicencePath = ERouteLinks.LegalEntityViewLicence.replace(':id', id).replace(
    ':licenceId',
    licenceId,
  );
  const viewLEBase = ERouteLinks.ViewLegalEntity.replace(':id', id);
  const detailLicencePath = ERouteLinks.DetailLicence.replace(':licenceId', licenceId);

  useEffect(() => {
    setIsFromLE(pathname.includes(leViewLicencePath));
  }, [pathname, leViewLicencePath]);

  useEffect(() => {
    if (loadingT) return;

    const commonType =
      type === ELegalEntityTypes.individual
        ? LEAccordionNames.INDIVIDUAL
        : LEAccordionNames.ORGANISATION;
    const commonTypeLabel =
      commonType === LEAccordionNames.INDIVIDUAL
        ? t('legalEntities.individual.accordion.label')
        : t('legalEntities.organization.accordion.label');

    const leExpanded = `${ERouteLinks.LegalEntities}?expand=${commonType}`;
    const viewLE = `${viewLEBase}?type=${commonType}&expand=${expand}`;

    const prevLink = isFromLE
      ? `${leViewLicencePath}?type=${commonType}&expand=${expand}&from=le`
      : `${detailLicencePath}?type=${commonType}&from=licences`;

    const breadcrumbBase = isFromLE
      ? [
          { label: t('module.legalEntity.name'), route: ERouteLinks.LegalEntities },
          { label: commonTypeLabel, route: leExpanded },
          { label: t('legalEntityDetails.legalEntityDetails.text'), route: viewLE },
        ]
      : [{ label: t('module.licences.name'), route: ERouteLinks.LicencesPage }];

    setBreadcrumbsForHeader([...breadcrumbBase, t('legalEntityDetails.view.licence.label')]);

    setBreadcrumbsForChildren([
      ...breadcrumbBase,
      { label: t('legalEntityDetails.view.licence.label'), route: prevLink },
    ]);
  }, [type, isFromLE, viewLEBase, expand, loadingT]);

  const handleAttachmentDownload = async (attachmentId: string, name: string) => {
    try {
      const url = await getLicenceAttachmentFile(licenceId, attachmentId, 'download');

      if (url) {
        const a = document.createElement('a');
        a.href = url;
        a.download = name;
        a.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.error('Error opening a file', err);
    }
  };

  const handleAttachmentView = async (attachmentId: string) => {
    try {
      const url = await getLicenceAttachmentFile(licenceId, attachmentId, 'view');
      if (url) {
        window.open(url, '_blank');
      }
    } catch (err) {
      console.error('Error opening a file', err);
    }
  };

  const handleVary = () => {
    LicenceStore.clearStore();
    if (isFromLE) {
      navigate(
        `${ERouteLinks.LegalEntityLicenceVary.replace(':id', id).replace(
          ':licenceId',
          licenceId as string,
        )}?type=${
          type === ELegalEntityTypes.individual
            ? LEAccordionNames.INDIVIDUAL
            : LEAccordionNames.ORGANISATION
        }& expand=${expand} `,
      );
    } else {
      navigate(
        `${ERouteLinks.DetailLicenceVary.replace(':licenceId', licenceId as string)}?type=${
          type === ELegalEntityTypes.individual
            ? LEAccordionNames.INDIVIDUAL
            : LEAccordionNames.ORGANISATION
        } `,
      );
    }
  };

  const canUserViewLegalEntity = () => {
    const legalId = typedLicenceDetails?.legal?.uniqueId;
    const legalVisibilityUniqueId = typedLicenceDetails?.legal?.visibilityUniqueId;

    const hasViewLEWithAccess =
      !!legalId &&
      hasPermissions([EPermission.VIEW_LE]) &&
      (legalVisibilityUniqueId === ELegalVisibility.PUBLIC ||
        (legalVisibilityUniqueId === ELegalVisibility.NON_PUBLIC &&
          account?.assignedLegalIds.includes(legalId)));

    return !!legalId && (hasPermissions([EPermission.VIEW_ALL_LE]) || hasViewLEWithAccess);
  };

  const renderOwnerTitleWithButton = () => {
    const ownerName = `${prefixForLE} ${getOwnerDisplayName(
      typedLicenceDetails?.owner || null,
    )} `;
    const legalId = typedLicenceDetails?.legal?.uniqueId;
    const legalType = typedLicenceDetails?.legal?.type;

    return (
      <>
        <Typography variant="h5" sx={{ fontWeight: 600, lineHeight: '2rem' }}>
          {ownerName}
        </Typography>
        {canUserViewLegalEntity() && legalId && legalType && isDesktop && (
          <Button
            id="licence_details_see_legal_entity-button"
            label={t('licenceDetails.seeDetails.button')}
            variant={EButtonVariants.outlined}
            size={EButtonSizes.small}
            onClick={() => {
              const route = ERouteLinks.ViewLegalEntity.replace(':id', legalId);
              navigate(`${route}?type=${type}`);
            }}
            sx={{
              width: '141px',
              '@media (max-width: 749px)': { width: '100%' },
              height: '32px',
              backgroundColor: colors.white,
            }}
          />
        )}
      </>
    );
  };

  const renderCustomFieldData = (customField: ILegalEntityCustomField) => {
    if (customField.customFieldType === ECustomFieldType.BOOL) {
      if (customField.value === null) {
        return '-';
      }
      return customField.value
        ? t('customFields.value.yes.label')
        : t('customFields.value.no.label');
    }
    if (customField.customFieldType === ECustomFieldType.DATE) {
      return formatDate(customField.value, shortDateFormat);
    }
    return customField.value;
  };

  return (
    <>
      <Breadcrumbs items={breadcrumbsForHeader} />
      <StyledHeaderContainer>
        <StyledPageTitle
          variant="h4"
          sx={{ width: { xs: '100%', sm: 'auto' }, mb: 0, mr: { xs: 0, sm: 4 } }}
        >
          {t('legalEntity.licenceDetails.title')}
        </StyledPageTitle>
        <StyledButtonsContainer>
          {(() => {
            const isActive = isLicenceActive(typedLicenceDetails?.general?.statusUniqueId);
            const isScheduled = isLicenceScheduled(
              typedLicenceDetails?.general?.statusUniqueId,
            );
            const isSuspended = isLicenceSuspended(
              typedLicenceDetails?.general?.statusUniqueId,
            );

            const canShowActionButtons =
              licenceAuthorityMatches && (isActive || isScheduled || isSuspended);

            if (!canShowActionButtons) {
              return null;
            }

            return (
              <>
                {canPrintLicence && (
                  <Button
                    id="legalEntity_licence_print-licence-button"
                    label={t('printLicence.button.label')}
                    size={EButtonSizes.small}
                    variant={EButtonVariants.contained}
                    onClick={() => {
                      setIsPrintLicenceModalOpen(true);
                    }}
                    sx={{
                      width: '157px',
                      '@media (max-width: 749px)': { width: '100%' },
                    }}
                  />
                )}
                {isSuspended && !licenceHasSuspendedParent && (
                  <Button
                    id="legalEntity_licence_reactivate-button"
                    label={t('reactivateLicence.modal.button.label')}
                    size={EButtonSizes.small}
                    variant={EButtonVariants.contained}
                    permission={EPermission.CREATE_MANAGE_LICENCE}
                    onClick={() => {
                      setIsReactivateModalOpen(true);
                    }}
                    sx={{
                      width: '157px',
                      '@media (max-width: 749px)': { width: '100%' },
                    }}
                  />
                )}
                {licenceAuthorityMatches &&
                  (typedLicenceDetails?.canBeVaried || caseVariationStatus?.caseUniqueId) &&
                  (caseVariationStatus?.caseUniqueId ||
                    hasPermissions([EPermission.ADD_CASES])) && (
                    <Button
                      id="legalEntity_licence_vary-button"
                      label={t('licenceDetails.varyLicence.button')}
                      size={EButtonSizes.small}
                      variant={EButtonVariants.contained}
                      permission={[EPermission.CREATE_MANAGE_LICENCE]}
                      onClick={() => {
                        if (!caseVariationStatus?.caseUniqueId) {
                          handleVary();
                        } else {
                          setIsVaryModalOpen(true);
                        }
                      }}
                      sx={{
                        width: '86px',
                        '@media (max-width: 749px)': { width: '100%' },
                      }}
                    />
                  )}
                {licenceAuthorityMatches &&
                  (typedLicenceDetails?.canBeRenewed || caseRenewalStatus?.caseUniqueId) &&
                  (caseRenewalStatus?.caseUniqueId ||
                    hasPermissions([EPermission.ADD_CASES])) && (
                    <Button
                      id="legalEntity_licence_renew-button"
                      label={t('licenceDetails.renewLicence.button')}
                      icon={EIconTypes.renew}
                      size={EButtonSizes.small}
                      variant={EButtonVariants.contained}
                      styleVariant={EButtonStyleVariant.success}
                      permission={[EPermission.CREATE_MANAGE_LICENCE]}
                      onClick={() => setIsRenewModalOpen(true)}
                      sx={{
                        width: '86px',
                        '@media (max-width: 749px)': { width: '100%' },
                      }}
                    />
                  )}
                {isActive && (
                  <Button
                    id="legalEntity_licence_surrender-button"
                    label={t('surrenderLicence.modal.button.label')}
                    icon={EIconTypes.close}
                    size={EButtonSizes.small}
                    styleVariant={EButtonStyleVariant.error}
                    variant={EButtonVariants.contained}
                    permission={EPermission.CREATE_MANAGE_LICENCE}
                    onClick={() => {
                      setIsSurrenderModalOpen(true);
                    }}
                    sx={{
                      width: '157px',
                      '@media (max-width: 749px)': { width: '100%' },
                    }}
                  />
                )}
                {isActive && (
                  <Button
                    id="legalEntity_licence_suspend-button"
                    label={t('suspendLicence.modal.button.label')}
                    icon={EIconTypes.close}
                    size={EButtonSizes.small}
                    styleVariant={EButtonStyleVariant.error}
                    variant={EButtonVariants.contained}
                    permission={EPermission.CREATE_MANAGE_LICENCE}
                    onClick={() => {
                      setIsSuspendModalOpen(true);
                    }}
                    sx={{
                      width: '136px',
                      '@media (max-width: 749px)': { width: '100%' },
                    }}
                  />
                )}
                {!isScheduled && !licenceHasSuspendedParent && (
                  <Button
                    id="legalEntity_licence_revoke-button"
                    label={t('revokeLicence.modal.button.label')}
                    icon={EIconTypes.close}
                    size={EButtonSizes.small}
                    styleVariant={EButtonStyleVariant.error}
                    variant={EButtonVariants.contained}
                    permission={EPermission.CREATE_MANAGE_LICENCE}
                    onClick={() => {
                      setIsRevokeModalOpen(true);
                    }}
                    sx={{
                      width: '125px',
                      '@media (max-width: 749px)': { width: '100%' },
                    }}
                  />
                )}
                {isScheduled && (
                  <Button
                    id="legalEntity_licence_cancel-button"
                    label={t('cancelLicence.modal.button.label')}
                    icon={EIconTypes.close}
                    size={EButtonSizes.small}
                    styleVariant={EButtonStyleVariant.error}
                    variant={EButtonVariants.contained}
                    permission={EPermission.CREATE_MANAGE_LICENCE}
                    onClick={() => {
                      setIsCancelModalOpen(true);
                    }}
                    sx={{
                      width: '125px',
                      '@media (max-width: 749px)': { width: '100%' },
                    }}
                  />
                )}
              </>
            );
          })()}
        </StyledButtonsContainer>
      </StyledHeaderContainer>

      {samePageAlert && (
        <Box sx={{ marginBottom: '16px', marginTop: '16px' }}>
          <Alert text={samePageAlert.text} variant={samePageAlert.variant} />
        </Box>
      )}

      {nextPageAlert && (
        <Box sx={{ marginBottom: '16px', marginTop: '16px' }}>
          <Alert text={nextPageAlert.text} variant={nextPageAlert.variant} />
        </Box>
      )}

      {isLegalEntityLicenceLoading ? (
        <Loader isLoading={isLegalEntityLicenceLoading} />
      ) : (
        typedLicenceDetails && (
          <div>
            <Grid container ref={elRef}>
              {(() => {
                const leftDaysNumber = typedLicenceDetails?.general?.expiryDate
                  ? Number(leftDays(typedLicenceDetails.general.expiryDate, t, true))
                  : null;

                return (
                  typedLicenceDetails?.general?.expiryDate &&
                  leftDaysNumber !== null &&
                  leftDaysNumber <= leftDaysNotify &&
                  !typedLicenceDetails.renewed &&
                  typedLicenceDetails?.general?.statusUniqueId ===
                    ELicenceStatusIds.ACTIVE && (
                    <Grid size={{ xs: 12 }} sx={{ mb: 2.5 }}>
                      <Alert
                        text={
                          leftDaysNumber > 0
                            ? `${t(
                                'legalEntity.licenceDetails.willExpire.text',
                              )} ${leftDaysNumber} ${t(
                                'legalEntity.licenceDetails.willExpire.days',
                              )} `
                            : t('legalEntity.licenceDetails.willExpireToday.text')
                        }
                        variant={EAlertVariants.warning}
                      />
                    </Grid>
                  )
                );
              })()}
              {typedLicenceDetails.hasAnyFirearmIllegal &&
                typedLicenceDetails?.general?.statusUniqueId === ELicenceStatusIds.ACTIVE && (
                  <Grid size={{ xs: 12 }} sx={{ mb: 2.5 }}>
                    <Alert
                      text={t('legalEntity.licenceDetails.hasAnyIllegalFirearm.text')}
                      variant={EAlertVariants.warning}
                    />
                  </Grid>
                )}
              {typedLicenceDetails.hasAnyFirearmInactive &&
                typedLicenceDetails?.general?.statusUniqueId === ELicenceStatusIds.ACTIVE && (
                  <Grid size={{ xs: 12 }} sx={{ mb: 2.5 }}>
                    <Alert
                      text={t('legalEntity.licenceDetails.hasAnyInactiveFirearm.text')}
                      variant={EAlertVariants.warning}
                    />
                  </Grid>
                )}
              {typedLicenceDetails.hasAnyFirearmNotAssignedToLegal &&
                typedLicenceDetails?.general?.statusUniqueId === ELicenceStatusIds.ACTIVE && (
                  <Grid size={{ xs: 12 }} sx={{ mb: 2.5 }}>
                    <Alert
                      text={t(
                        'legalEntity.licenceDetails.hasAnyFirearmNotAssignedToLegal.text',
                      )}
                      variant={EAlertVariants.warning}
                    />
                  </Grid>
                )}
              {typedLicenceDetails.hasInactiveOwner && (
                <Grid size={{ xs: 12 }} sx={{ mb: 2.5 }}>
                  <Alert
                    text={t('legalEntity.licenceDetails.hasInactiveOwner.text')}
                    variant={EAlertVariants.warning}
                  />
                </Grid>
              )}
              {typedLicenceDetails.printWarning && (
                <Grid size={{ xs: 12 }} sx={{ mb: 2.5 }}>
                  <Alert
                    text={t(typedLicenceDetails.printWarning)}
                    variant={EAlertVariants.warning}
                  />
                </Grid>
              )}
              <SubsectionHeader>
                {t('legalEntity.licenceDetails.generalInformation.header')}
              </SubsectionHeader>
              <DetailsContainer
                container
                size={{ xs: 12 }}
                spacing={2}
                rowSpacing={2}
                sx={{ marginBottom: '32px' }}
              >
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                  <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                    {t('legalEntity.licenceDetails.generalInformation.licenceName')}
                  </Typography>
                  <Typography variant="body2">
                    {emptyFieldHolder(typedLicenceDetails?.general?.name)}
                  </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                  <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                    {t('legalEntity.licenceDetails.generalInformation.licenceCode')}
                  </Typography>
                  <Typography variant="body2">
                    {emptyFieldHolder(typedLicenceDetails?.general?.code)}
                  </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                  <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                    {t('legalEntity.licenceDetails.generalInformation.licenceNumber')}
                  </Typography>
                  <Typography variant="body2">
                    {emptyFieldHolder(typedLicenceDetails?.general?.licenceNumber)}
                  </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                  <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                    {t('legalEntity.licenceDetails.generalInformation.licenceStatus')}
                  </Typography>
                  <Typography variant="body2">
                    <Chips
                      text={getDictionaryValue(
                        typedLicenceDetails?.general?.statusUniqueId,
                        weaponLicenceStatus,
                      )}
                      variant={getLicenceStatusChipVariant(
                        typedLicenceDetails?.general?.statusUniqueId ?? '',
                      )}
                      fullWidth
                    />
                  </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                  <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                    {t('legalEntity.licenceDetails.generalInformation.startDate')}
                  </Typography>
                  <Typography variant="body2">
                    {typedLicenceDetails?.general?.startDate
                      ? formatDate(typedLicenceDetails.general.startDate, shortDateFormat)
                      : emptyFieldHolder('')}
                  </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                  <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                    {t('legalEntity.licenceDetails.generalInformation.expiryDate')}
                  </Typography>
                  <Typography variant="body2">
                    {typedLicenceDetails?.general?.expiryDate
                      ? formatDate(typedLicenceDetails.general.expiryDate, shortDateFormat)
                      : emptyFieldHolder('')}
                  </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                  <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                    {t('caseManagement.cases.licenceAuthority.label')}
                  </Typography>
                  <Typography variant="body2">
                    {emptyFieldHolder(
                      getDictionaryValue(
                        typedLicenceDetails?.general?.licenceAuthorityUniqueId,
                        weaponLicencingAuthority,
                      ),
                    )}
                  </Typography>
                </Grid>
                {typedLicenceDetails?.general?.paymentStatusUniqueId && (
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                      {t('legalEntity.licenceDetails.generalInformation.paymentStatus')}
                    </Typography>
                    <Typography variant="body2">
                      <Chips
                        text={getDictionaryValue(
                          typedLicenceDetails?.general?.paymentStatusUniqueId,
                          weaponLicencePaymentStatus,
                        )}
                        variant={getPaymentStatusChipVariant(
                          typedLicenceDetails?.general?.paymentStatusUniqueId,
                        )}
                        fullWidth
                      />
                    </Typography>
                  </Grid>
                )}

                {typedLicenceDetails?.general?.paymentStatusUniqueId &&
                  latestMeaningfullAction === ELicenceHistoryActions.RENEW && (
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                      <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                        {t('legalEntity.licenceDetails.generalInformation.renewalFee')}
                      </Typography>
                      <Typography variant="body2">
                        {priceFormat(latestMeaningfullActionPrice)} {currency}
                      </Typography>
                    </Grid>
                  )}

                {typedLicenceDetails?.general?.paymentStatusUniqueId &&
                  latestMeaningfullAction === ELicenceHistoryActions.VARY && (
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                      <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                        {t('legalEntity.licenceDetails.generalInformation.varyFee')}
                      </Typography>
                      <Typography variant="body2">
                        {priceFormat(latestMeaningfullActionPrice)} {currency}
                      </Typography>
                    </Grid>
                  )}

                {typedLicenceDetails?.general?.paymentStatusUniqueId &&
                  latestMeaningfullAction === ELicenceHistoryActions.CREATE && (
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                      <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                        {t('legalEntity.licenceDetails.generalInformation.applyForFee')}
                      </Typography>
                      <Typography variant="body2">
                        {priceFormat(latestMeaningfullActionPrice)} {currency}
                      </Typography>
                    </Grid>
                  )}
              </DetailsContainer>

              <Grid size={{ xs: 12 }} sx={{ marginTop: '32px' }}>
                <SubsectionHeader>
                  {t('legalEntity.licenceDetails.owner.header')}
                </SubsectionHeader>
              </Grid>

              {typedLicenceDetails.hasAnyLeDataChanged &&
                typedLicenceDetails?.general?.statusUniqueId === ELicenceStatusIds.ACTIVE && (
                  <Grid size={{ xs: 12 }} sx={{ mb: 2.5 }}>
                    <Alert
                      text={t('legalEntity.licenceDetails.hasAnyLeDataChanged.text')}
                      variant={EAlertVariants.warning}
                    />
                  </Grid>
                )}

              <Grid size={{ xs: 12 }}>
                <DetailsTemplate
                  title={`${prefixForLE} ${getOwnerDisplayName(
                    typedLicenceDetails?.owner || null,
                  )} `}
                  disableActions
                  customTitleContent={renderOwnerTitleWithButton()}
                >
                  {type === ELegalEntityTypes.individual ? (
                    <Grid
                      container
                      size={{ xs: 12 }}
                      sx={{
                        flexWrap: { xs: 'wrap', sm: 'nowrap' },
                        justifyContent: 'flex-start',
                        gap: '20px',
                      }}
                    >
                      {hasWeaponLicenceModule() && (
                        <Grid
                          container
                          sx={{
                            justifyContent: 'flex-start',
                            alignContent: 'flex-start',
                            width: '270px',
                          }}
                        >
                          <StyledPhoto>
                            {legalEntityPhoto ? (
                              <img
                                src={legalEntityPhoto}
                                alt="ovner_photo"
                                style={{ width: '270px', height: '320px', objectFit: 'cover' }}
                              />
                            ) : (
                              <EmptyPhotoContainer />
                            )}
                          </StyledPhoto>
                        </Grid>
                      )}
                      <Grid
                        container
                        columnSpacing={2}
                        sx={{
                          width: hasWeaponLicenceModule()
                            ? { xs: '100%', sm: 'calc(100% - 290px)' }
                            : '100%',
                          rowGap: 2,
                        }}
                      >
                        <Grid size={{ xs: 12 }}>
                          <Stack>
                            <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                              {t('legalEntityDetails.displayUniqueId.label')}
                            </Typography>
                            <Typography variant="body2">
                              {legalEntity?.displayUniqueId}
                            </Typography>
                          </Stack>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                          <Stack>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.firstName}
                              variant="subtitle2"
                              label
                              sx={{ marginBottom: '4px' }}
                            >
                              {t('legalEntityDetails.firstName.label')}
                            </StyledOwnerDetail>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.firstName}
                              variant="body2"
                            >
                              {legalEntity?.firstName}
                            </StyledOwnerDetail>
                          </Stack>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                          <Stack>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.middleNames}
                              variant="subtitle2"
                              label
                              sx={{ marginBottom: '4px' }}
                            >
                              {t('legalEntityDetails.middleNames.label')}
                            </StyledOwnerDetail>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.middleNames}
                              variant="body2"
                            >
                              {emptyFieldHolder(legalEntity?.middleNames)}
                            </StyledOwnerDetail>
                          </Stack>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                          <Stack>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.lastName}
                              label
                              variant="subtitle2"
                              sx={{ marginBottom: '4px' }}
                            >
                              {t('legalEntityDetails.lastName.label')}
                            </StyledOwnerDetail>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.lastName}
                              variant="body2"
                            >
                              {legalEntity?.lastName}
                            </StyledOwnerDetail>
                          </Stack>
                        </Grid>
                        {!hiddenFieldsName.includes(EFieldsOptional.secondSurname) && (
                          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                            <Stack>
                              <StyledOwnerDetail
                                warning={!!licenceMismatchingLegalEntity?.secondSurname}
                                label
                                variant="subtitle2"
                                sx={{ marginBottom: '4px' }}
                              >
                                {t('legalEntityDetails.secondSurname.label')}
                              </StyledOwnerDetail>
                              <StyledOwnerDetail
                                warning={!!licenceMismatchingLegalEntity?.secondSurname}
                                variant="body2"
                              >
                                {notApplicableFieldHolder(
                                  t,
                                  legalEntity.individual.secondSurname,
                                  licence?.owner.individual.secondSurname,
                                )}
                              </StyledOwnerDetail>
                            </Stack>
                          </Grid>
                        )}
                        <Grid size={{ xs: 12 }}>
                          <StyledDivider />
                          <StyledSectionTypography>
                            {t('legalEntityDetails.generalInformation')}
                          </StyledSectionTypography>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                          <Stack>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.documentType}
                              variant="subtitle2"
                              label
                              sx={{ marginBottom: '4px' }}
                            >
                              {t('legalEntityDetails.documentType.label')}
                            </StyledOwnerDetail>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.documentType}
                              variant="body2"
                            >
                              {notApplicableFieldHolder(
                                t,
                                getDictionaryValue(
                                  legalEntity.identityDocumentTypeUniqueId,
                                  identificationDocumentType,
                                ),
                                licence?.owner.individual.documentTypeAndNumber,
                              )}
                            </StyledOwnerDetail>
                          </Stack>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                          <Stack>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.documentNumber}
                              label
                              variant="subtitle2"
                              sx={{ marginBottom: '4px' }}
                            >
                              {t('legalEntityDetails.identityDocumentNumber.label')}
                            </StyledOwnerDetail>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.documentNumber}
                              variant="body2"
                            >
                              {notApplicableFieldHolder(
                                t,
                                legalEntity?.identityDocumentNumber,
                                licence?.owner.individual.documentTypeAndNumber,
                              )}
                            </StyledOwnerDetail>
                          </Stack>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                          <Stack>
                            <Grid>
                              <StyledOwnerDetail
                                warning={!!licenceMismatchingLegalEntity?.gender}
                                label
                                variant="subtitle2"
                                sx={{ marginBottom: '4px' }}
                              >
                                {t('legalEntityDetails.gender.label')}
                              </StyledOwnerDetail>
                            </Grid>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.gender}
                              variant="body2"
                              id="gender"
                            >
                              {notApplicableFieldHolder(
                                t,
                                getDictionaryValue(legalEntity.genderUniqueId, gender),
                                licence?.owner.individual.gender,
                              )}
                            </StyledOwnerDetail>
                          </Stack>
                        </Grid>
                        {!hiddenFieldsName.includes(EFieldsOptional.occupation) &&
                          legalEntity.prefixGroupUniqueId ===
                            EDictionaryPrefixTypesUniqueId.civilianPrefix && (
                            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                              <Stack>
                                <StyledOwnerDetail
                                  warning={!!licenceMismatchingLegalEntity?.occupation}
                                  label
                                  variant="subtitle2"
                                  sx={{ marginBottom: '4px' }}
                                >
                                  {t('legalEntityDetails.occupation.label')}
                                </StyledOwnerDetail>
                                <StyledOwnerDetail
                                  warning={!!licenceMismatchingLegalEntity?.occupation}
                                  variant="body2"
                                >
                                  {notApplicableFieldHolder(
                                    t,
                                    legalEntity.individual.occupation,
                                    licence?.owner.individual.occupation,
                                  )}
                                </StyledOwnerDetail>
                              </Stack>
                            </Grid>
                          )}

                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                          <Stack>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.dateOfBirth}
                              label
                              variant="subtitle2"
                              sx={{ marginBottom: '4px' }}
                            >
                              {t('legalEntityDetails.dateOfBirth.label')}
                            </StyledOwnerDetail>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.dateOfBirth}
                              variant="body2"
                            >
                              {notApplicableFieldHolder(
                                t,
                                legalEntity?.dateOfBirth
                                  ? `${formatDate(legalEntity.dateOfBirth, shortDateFormat)}${
                                      getFullYearsSince(legalEntity.dateOfBirth) > 0
                                        ? ` (${getFullYearsSince(legalEntity.dateOfBirth)} ${t(
                                            'legalEntity.yearsOld',
                                          )})`
                                        : ''
                                    } `
                                  : '',
                                licence?.owner.individual.dateOfBirth,
                              )}
                            </StyledOwnerDetail>
                          </Stack>
                        </Grid>
                        {!hiddenFieldsName.includes(EFieldsOptional.placeOfBirth) && (
                          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                            <Stack>
                              <StyledOwnerDetail
                                warning={!!licenceMismatchingLegalEntity?.placeOfBirth}
                                label
                                variant="subtitle2"
                                sx={{ marginBottom: '4px' }}
                              >
                                {t('legalEntityDetails.placeOfBirth.label')}
                              </StyledOwnerDetail>
                              <StyledOwnerDetail
                                warning={!!licenceMismatchingLegalEntity?.placeOfBirth}
                                variant="body2"
                              >
                                {notApplicableFieldHolder(
                                  t,
                                  legalEntity?.placeOfBirth,
                                  licence?.owner.individual.placeOfBirth,
                                )}
                              </StyledOwnerDetail>
                            </Stack>
                          </Grid>
                        )}
                        {!hiddenFieldsName.includes(EFieldsOptional.height) && (
                          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                            <Stack>
                              <StyledOwnerDetail
                                warning={!!licenceMismatchingLegalEntity?.height}
                                label
                                variant="subtitle2"
                                sx={{ marginBottom: '4px' }}
                              >
                                {t('legalEntityDetails.height.label')}
                              </StyledOwnerDetail>
                              <StyledOwnerDetail
                                warning={!!licenceMismatchingLegalEntity?.height}
                                variant="body2"
                              >
                                {notApplicableFieldHolder(
                                  t,
                                  legalEntity?.height ? `${legalEntity.height} ${unit} ` : '',
                                  licence?.owner.individual.height,
                                )}
                              </StyledOwnerDetail>
                            </Stack>
                          </Grid>
                        )}

                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                          <Stack>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.nationality}
                              label
                              variant="subtitle2"
                              sx={{ marginBottom: '4px' }}
                            >
                              {t('legalEntityDetails.nationality.label')}
                            </StyledOwnerDetail>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.nationality}
                              variant="body2"
                            >
                              {notApplicableFieldHolder(
                                t,
                                getDictionaryValue(
                                  legalEntity.nationalityUniqueId,
                                  nationality,
                                ),
                                licence?.owner.individual.nationality,
                              )}
                            </StyledOwnerDetail>
                          </Stack>
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                          <Stack>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.primaryAddress}
                              label
                              variant="subtitle2"
                              sx={{ marginBottom: '4px' }}
                            >
                              {t('legalEntityDetails.address.label')}
                            </StyledOwnerDetail>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.primaryAddress}
                              variant="body2"
                            >
                              {notApplicableFieldHolder(
                                t,
                                formatAddress(
                                  typedLicenceDetails?.owner?.primaryAddress,
                                  country,
                                ) ?? '',
                                licence?.owner.individual.primaryAddress,
                              )}
                            </StyledOwnerDetail>
                          </Stack>
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid container columnSpacing={2} sx={{ rowGap: 2 }}>
                      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                        <Stack>
                          <StyledOwnerDetail
                            warning={!!licenceMismatchingLegalEntity?.organisationName}
                            label
                            variant="subtitle2"
                            sx={{ marginBottom: '4px' }}
                          >
                            {t('legalEntity.licence.name.label')}
                          </StyledOwnerDetail>
                          <StyledOwnerDetail
                            warning={!!licenceMismatchingLegalEntity?.organisationName}
                            variant="body2"
                          >
                            {legalEntity?.organisationName}
                          </StyledOwnerDetail>
                        </Stack>
                      </Grid>

                      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                        <Stack>
                          <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                            {t('legalEntity.licence.uniqueID.label')}
                          </Typography>
                          {notApplicableFieldHolder(t, legalEntity?.displayUniqueId)}
                        </Stack>
                      </Grid>

                      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                        <Stack>
                          <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                            {t('legalEntity.licence.organisationCategory.label')}
                          </Typography>
                          {notApplicableFieldHolder(
                            t,
                            getDictionaryValue(
                              legalEntity.organisationCategoryUniqueId,
                              organisationCategory,
                            ),
                          )}
                        </Stack>
                      </Grid>

                      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                        <Stack>
                          <StyledOwnerDetail
                            warning={!!licenceMismatchingLegalEntity?.organisationTypes}
                            label
                            variant="subtitle2"
                            sx={{ marginBottom: '4px' }}
                          >
                            {t('legalEntity.licence.organisationType.label')}
                          </StyledOwnerDetail>
                          <StyledOwnerDetail
                            warning={!!licenceMismatchingLegalEntity?.organisationTypes}
                            variant="body2"
                          >
                            {notApplicableFieldHolder(
                              t,
                              findInDictionaryList(
                                legalEntity.organisationTypeUniqueIds,
                                mergeDictionaries([
                                  organisationStateType,
                                  organisationCivilianType,
                                  organisationPoliceType,
                                  organisationMilitaryType,
                                ]),
                              )?.join(', ') || '',
                              licence?.owner.organisation.organisationType,
                            )}
                          </StyledOwnerDetail>
                        </Stack>
                      </Grid>
                      {!hiddenFieldsName.includes(EFieldsOptional.departmentName) && (
                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                          <Stack>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.departmentName}
                              label
                              variant="subtitle2"
                              sx={{ marginBottom: '4px' }}
                            >
                              {t('legalEntity.licence.departmentName.label')}
                            </StyledOwnerDetail>
                            <StyledOwnerDetail
                              warning={!!licenceMismatchingLegalEntity?.departmentName}
                              variant="body2"
                            >
                              {notApplicableFieldHolder(
                                t,
                                legalEntity?.departmentName,
                                licence?.owner.organisation.departmentName,
                              )}
                            </StyledOwnerDetail>
                          </Stack>
                        </Grid>
                      )}

                      <Grid size={{ xs: 12 }}>
                        <Stack>
                          <StyledOwnerDetail
                            warning={!!licenceMismatchingLegalEntity?.primaryAddress}
                            label
                            variant="subtitle2"
                            sx={{ marginBottom: '4px' }}
                          >
                            {t('legalEntityDetails.address.label')}
                          </StyledOwnerDetail>
                          <StyledOwnerDetail
                            warning={!!licenceMismatchingLegalEntity?.primaryAddress}
                            variant="body2"
                          >
                            {notApplicableFieldHolder(
                              t,
                              formatAddress(
                                typedLicenceDetails?.owner?.primaryAddress,
                                country,
                              ) ?? '',
                              licence?.owner.organisation.primaryAddress,
                            )}
                          </StyledOwnerDetail>
                        </Stack>
                      </Grid>
                    </Grid>
                  )}
                  {(() => {
                    const legalId = typedLicenceDetails?.legal?.uniqueId;
                    const legalType = typedLicenceDetails?.legal?.type;

                    if (canUserViewLegalEntity() && legalId && legalType && !isDesktop) {
                      return (
                        <Grid
                          container
                          size={{ xs: 12 }}
                          sx={{
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderTop: `1px solid ${colors.primary100}`,
                            mb: 2,
                            mt: 1,
                            pt: 2,
                          }}
                        >
                          <Grid size={{ xs: 12, sm: 6 }} sx={{ mb: { xs: 2, sm: 0 } }}>
                            <Typography variant="button" sx={{ textTransform: 'uppercase' }}>
                              {t('legalEntity.licenceDetails.owner.actions.column')}:{' '}
                            </Typography>
                          </Grid>
                          <Grid
                            size={{ xs: 12, sm: 6 }}
                            sx={{ display: 'flex', justifyContent: 'flex-end' }}
                          >
                            <Button
                              id="licence_details_see_legal_entity_mobile-button"
                              label={t('licenceDetails.seeDetails.button')}
                              variant={EButtonVariants.outlined}
                              size={EButtonSizes.small}
                              onClick={() =>
                                navigate(
                                  `${ERouteLinks.ViewLegalEntity.replace(':id', legalId)}?type=${type}`,
                                )
                              }
                              fullWidth
                            />
                          </Grid>
                        </Grid>
                      );
                    }
                    return null;
                  })()}
                </DetailsTemplate>
              </Grid>

              <Grid size={{ xs: 12 }} sx={{ marginTop: '32px' }}>
                <SubsectionHeader>
                  {t('legalEntity.licenceDetails.conditions.header')}
                </SubsectionHeader>
              </Grid>
              <DetailsContainer
                container
                columnSpacing={2.5}
                style={{ rowGap: 2 }}
                sx={{ marginBottom: '32px' }}
              >
                {typedLicenceDetails?.conditions?.competencyUniqueId && (
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                      {t('legalEntity.licenceDetails.conditions.compentency')}
                    </Typography>
                    <Typography variant="body2">
                      {getDictionaryValue(
                        typedLicenceDetails?.conditions?.competencyUniqueId,
                        weaponLicenceCompetency,
                      )}
                    </Typography>
                  </Grid>
                )}
                {typedLicenceDetails?.conditions?.carry && (
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                      {t('legalEntity.licenceDetails.conditions.carryConditions')}
                    </Typography>
                    <Typography variant="body2">
                      {getDictionaryValue(
                        typedLicenceDetails?.conditions?.carry,
                        weaponLicenceCondition,
                      )}
                    </Typography>
                  </Grid>
                )}
                {typedLicenceDetails?.conditions?.areaOfValidityUniqueId ? (
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                      {t('legalEntity.licenceDetails.conditions.areaOfValidity')}
                    </Typography>
                    <Typography variant="body2">
                      {getDictionaryValue(
                        typedLicenceDetails?.conditions?.areaOfValidityUniqueId,
                        region,
                      )}
                    </Typography>
                  </Grid>
                ) : (
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                      {t('legalEntity.licenceDetails.conditions.areaOfValidity')}
                    </Typography>
                    <Typography variant="body2">
                      {t('licence.areaRestriction.national')}
                    </Typography>
                  </Grid>
                )}
                {typedLicenceDetails?.conditions?.weaponCategorisationUniqueId && (
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                      {t('legalEntity.licenceDetails.conditions.weaponCat')}
                    </Typography>
                    <Typography variant="body2">
                      {getDictionaryValue(
                        typedLicenceDetails?.conditions?.weaponCategorisationUniqueId,
                        weaponLicenceCategory,
                      )}
                    </Typography>
                  </Grid>
                )}
                {typedLicenceDetails?.conditions?.weaponNumberLimit > 0 && (
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                      {t('legalEntity.licenceDetails.conditions.weaponNumLimit')}
                    </Typography>
                    <Typography variant="body2">
                      {emptyFieldHolder(typedLicenceDetails?.conditions?.weaponNumberLimit)}
                    </Typography>
                  </Grid>
                )}
                {typedLicenceDetails?.conditions?.goodReason && (
                  <Grid size={{ xs: 12 }}>
                    <Typography variant="subtitle2" sx={{ marginBottom: '8px' }}>
                      {t('legalEntity.licenceDetails.conditions.goodReason')}
                    </Typography>
                    <Grid container style={{ whiteSpace: 'pre-line' }}>
                      {typedLicenceDetails?.conditions?.goodReason}
                    </Grid>
                  </Grid>
                )}
                {selectedReasons.length > 0 && (
                  <Grid size={{ xs: 12 }}>
                    <Typography variant="subtitle2" sx={{ marginBottom: '8px' }}>
                      {t('legalEntity.licenceDetails.conditions.goodReason')}
                    </Typography>
                    <Grid container>
                      {selectedReasons.map((reason) => (
                        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={reason.uniqueId}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked
                                disabled
                                size="small"
                                sx={{
                                  padding: '2px 4px 2px 0px',
                                  '& input': {
                                    width: '16px',
                                    height: '16px',
                                  },
                                  '&.Mui-checked': {
                                    color: 'grey.400',
                                  },
                                  '&.Mui-disabled': {
                                    color: 'grey.400',
                                  },
                                }}
                              />
                            }
                            label={
                              <Typography
                                variant="body2"
                                sx={{
                                  color: 'text.primary',
                                  fontSize: '0.875rem',
                                }}
                              >
                                {reason.name}
                              </Typography>
                            }
                            sx={{
                              margin: 0,
                              width: '100%',
                              '& .MuiFormControlLabel-label': {
                                fontSize: '0.875rem',
                              },
                            }}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                )}
                {typedLicenceDetails?.conditions?.additionalConditions && (
                  <Grid size={{ xs: 12 }}>
                    <StyledDivider />
                    <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                      {t('legalEntity.licenceDetails.conditions.additionalConditions')}
                    </Typography>
                    {typedLicenceDetails?.conditions?.additionalConditions ? (
                      getHtmlText(typedLicenceDetails.conditions.additionalConditions)
                    ) : (
                      <Typography variant="body2">{emptyFieldHolder('')}</Typography>
                    )}
                  </Grid>
                )}
              </DetailsContainer>

              <Grid size={{ xs: 12 }} sx={{ marginTop: '32px' }}>
                <SubsectionHeader>
                  {t('legalEntity.licenceDetails.safeStorage.header')}
                </SubsectionHeader>
              </Grid>
              <DetailsContainer
                container
                spacing={2}
                rowSpacing={2}
                sx={{ marginBottom: '32px' }}
              >
                {(() => {
                  const hasSafeStorages =
                    typedLicenceDetails?.conditions?.safeStorages &&
                    typedLicenceDetails.conditions.safeStorages.length > 0;
                  const hasDescription =
                    typedLicenceDetails?.conditions?.safeStorageDescription;

                  if (hasSafeStorages) {
                    return (
                      <Grid size={{ xs: 12 }}>
                        <Typography variant="subtitle2" sx={{ marginBottom: '8px' }}>
                          {t('legalEntity.licenceDetails.safeStorage.locations')}
                        </Typography>
                        <Typography
                          variant="body2"
                          component="div"
                          sx={{
                            color: '#111827',
                            fontSize: '0.875rem',
                            lineHeight: 1.43,
                            whiteSpace: 'pre-line',
                          }}
                        >
                          {createSafeStorageAddressList(
                            typedLicenceDetails.conditions.safeStorages!,
                            country,
                            t,
                          )}
                        </Typography>
                      </Grid>
                    );
                  }
                  if (hasDescription) {
                    return (
                      <Grid size={{ xs: 12 }}>
                        <Typography variant="subtitle2" sx={{ marginBottom: '8px' }}>
                          {t('legalEntity.licenceDetails.safeStorage.description')}
                        </Typography>
                        {getHtmlText(typedLicenceDetails.conditions.safeStorageDescription)}
                      </Grid>
                    );
                  }

                  return (
                    <Grid size={{ xs: 12 }}>
                      <Typography
                        variant="body2"
                        sx={{ fontStyle: 'italic', color: colors.gray500 }}
                      >
                        {t('legalEntity.licenceDetails.safeStorage.missing')}
                      </Typography>
                    </Grid>
                  );
                })()}
              </DetailsContainer>
              <Grid size={{ xs: 12 }} sx={{ marginTop: '32px' }}>
                <Accordion
                  title={t('legalEntity.licenceDetails.weapon.header')}
                  subtitle={`${t('legalEntity.licenceDetails.weapon.limitNumber.text')} 
                      ${
                        typedLicenceDetails?.conditions?.weaponNumberLimit
                          ? `${licenceWeapon.length} / ${typedLicenceDetails?.conditions?.weaponNumberLimit}`
                          : t('legalEntity.licenceDetails.weapon.unlimited.text')
                      } `}
                  name="link-weapon"
                  key="link-weapon"
                  alwaysExpanded
                  hideExpandIcon
                />
              </Grid>
              <DetailsContainerWhite
                container
                size={{ xs: 12 }}
                spacing={2}
                sx={{ marginBottom: '32px', gap: 2 }}
              >
                {!licenceWeapon.length &&
                  typedLicenceDetails &&
                  licenceAuthorityMatches &&
                  typedLicenceDetails.general.statusUniqueId === ELicenceStatusIds.ACTIVE && (
                    <Grid container size={{ xs: 12 }} sx={{ justifyContent: 'right' }}>
                      <Button
                        id="legalEntity_licence_linkWeapon-button"
                        variant={EButtonVariants.contained}
                        icon={EIconTypes.plus}
                        permission={EPermission.CREATE_MANAGE_LICENCE}
                        label={t('legalEntity.licenceDetails.linkWeapon.label')}
                        onClick={() => {
                          navigate(
                            `${ERouteLinks.LegalEntityLicenceLinkWeapon.replace(
                              ':id',
                              isFromLE
                                ? id
                                : (typedLicenceDetails?.owner?.legalUniqueId as string),
                            ).replace(':licenceId', licenceId as string)}?type=${
                              type === ELegalEntityTypes.individual
                                ? LEAccordionNames.INDIVIDUAL
                                : LEAccordionNames.ORGANISATION
                            }& expand=${expand} `,
                          );
                        }}
                      />
                    </Grid>
                  )}

                <Grid size={{ xs: 12 }} container>
                  {isDesktop ? (
                    <Table
                      columns={weaponTableColumns({
                        propsLink: `?type=${
                          type === ELegalEntityTypes.individual
                            ? LEAccordionNames.INDIVIDUAL
                            : LEAccordionNames.ORGANISATION
                        }& expand=${expand} `,
                        state: {
                          breadcrumb: [breadcrumbsForChildren],
                        },
                        leId: isFromLE
                          ? id
                          : (typedLicenceDetails?.owner?.legalUniqueId as string),
                        licenceId: licenceId as string,
                        account,
                        hasViewAllFirearmsPermission:
                          hasPermissions(EPermission.VIEW_ALL_FIREARMS) === true,
                        hasViewAllLEPermission:
                          hasPermissions(EPermission.VIEW_ALL_LE) === true,
                        licenceOwnerUniqueId: typedLicenceDetails?.owner?.legalUniqueId,
                        showInfoColumn: false,
                        t,
                      })}
                      dataSource={mapWeaponToDataSource(
                        licenceWeapon,
                        state,
                        firearmType,
                        make,
                        model,
                        caliber,
                        firearmAction,
                      )}
                    />
                  ) : (
                    <CardList
                      items={mapWeaponToDataSource(
                        licenceWeapon,
                        state,
                        firearmType,
                        make,
                        model,
                        caliber,
                        firearmAction,
                      )}
                      render={(data, index) => (
                        <WeaponTableCard
                          data={data}
                          propsLink={`?type=${
                            type === ELegalEntityTypes.individual
                              ? LEAccordionNames.INDIVIDUAL
                              : LEAccordionNames.ORGANISATION
                          }&expand=${expand} `}
                          state={{
                            breadcrumb: [breadcrumbsForChildren],
                          }}
                          leId={
                            isFromLE
                              ? id
                              : (typedLicenceDetails?.owner?.legalUniqueId as string)
                          }
                          licenceId={licenceId as string}
                          account={account}
                          hasViewAllFirearmsPermission={
                            hasPermissions(EPermission.VIEW_ALL_FIREARMS) === true
                          }
                          key={index}
                        />
                      )}
                    />
                  )}
                </Grid>
              </DetailsContainerWhite>

              <Grid size={{ xs: 12 }} container sx={{ marginTop: '32px' }}>
                <SubsectionHeader>
                  {t('legalEntity.licenceDetails.attachments.header')}
                </SubsectionHeader>
              </Grid>
              <DetailsContainerWhite
                container
                spacing={2}
                rowSpacing={2}
                sx={{ marginBottom: '32px' }}
              >
                {licenceAttachments && licenceAttachments.content.length > 0 ? (
                  <Grid container size={{ xs: 12 }}>
                    {isDesktop ? (
                      <Table
                        columns={attachmentsTableColumns({
                          handleView: (attachmentId: string) => {
                            handleAttachmentView(attachmentId);
                          },
                          handleDownload: (attachmentId: string, name: string) => {
                            handleAttachmentDownload(attachmentId, name);
                          },
                          showView: true,
                          shortDateFormat,
                        })}
                        dataSource={mapAttachmentsToDataSource(
                          licenceAttachments.content,
                          parseDictionary(attachmentDocumentTypeData, 'name'),
                        )}
                      />
                    ) : (
                      <CardList
                        items={mapAttachmentsToDataSource(
                          licenceAttachments.content,
                          parseDictionary(attachmentDocumentTypeData, 'name'),
                        )}
                        render={(data, index) => (
                          <AttachmentTableCard
                            data={data}
                            handleView={(attachmentId: string) => {
                              handleAttachmentView(attachmentId);
                            }}
                            handleDownload={(attachmentId: string, name: string) => {
                              handleAttachmentDownload(attachmentId, name);
                            }}
                            showView={true}
                            shortDateFormat={shortDateFormat}
                            key={index}
                          />
                        )}
                      />
                    )}
                  </Grid>
                ) : (
                  <Grid size={{ xs: 12 }}>
                    <Typography
                      variant="body2"
                      sx={{ fontStyle: 'italic', color: colors.gray500 }}
                    >
                      {t('legalEntity.licenceDetails.attachments.missing')}
                    </Typography>
                  </Grid>
                )}
              </DetailsContainerWhite>

              <Grid size={{ xs: 12 }} container sx={{ marginTop: '32px' }}>
                <SubsectionHeader>
                  {t('legalEntity.licenceDetails.additionalInfo.header')}
                </SubsectionHeader>
              </Grid>
              <DetailsContainer
                container
                spacing={2}
                rowSpacing={2}
                sx={{ marginBottom: '32px' }}
              >
                <Grid size={{ xs: 12 }}>
                  <Typography variant="subtitle2" sx={{ marginBottom: '8px' }}>
                    {t('legalEntity.licenceDetails.additionalInfo.header')}
                  </Typography>
                  {typedLicenceDetails?.additionalInformation ? (
                    <Typography variant="body2" style={{ whiteSpace: 'pre-line' }}>
                      {typedLicenceDetails?.additionalInformation}
                    </Typography>
                  ) : (
                    <Typography
                      variant="body2"
                      sx={{ fontStyle: 'italic', color: colors.gray500 }}
                    >
                      {t('legalEntity.licenceDetails.additionalInfo.missing')}
                    </Typography>
                  )}
                </Grid>
              </DetailsContainer>

              {!!typedLicenceDetails?.customFields?.length && (
                <>
                  <Grid size={{ xs: 12 }} container sx={{ marginTop: '32px' }}>
                    <SubsectionHeader>
                      {t('legalEntity.licence.customFields.label')}
                    </SubsectionHeader>
                  </Grid>
                  <DetailsContainer
                    container
                    spacing={2}
                    rowSpacing={2}
                    sx={{ marginBottom: '32px' }}
                  >
                    {typedLicenceDetails?.customFields?.map((customField) => (
                      <Stack
                        key={customField.customFieldUniqueId}
                        sx={{ gridColumn: { xs: 'span 12', sm: 'span 6' } }}
                      >
                        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                          {customField?.translations?.filter(
                            (translation) =>
                              selectedLanguage?.uniqueId === translation.languageUniqueId,
                          )?.[0]?.name ||
                            customField?.translations?.filter(
                              (translation) =>
                                defaultLanguage?.uniqueId === translation.languageUniqueId,
                            )?.[0]?.name}
                        </Typography>
                        <Typography
                          variant="body2"
                          id={`customField_${customField.customFieldUniqueId} `}
                        >
                          {emptyFieldHolder(renderCustomFieldData(customField))}
                        </Typography>
                      </Stack>
                    ))}
                  </DetailsContainer>
                </>
              )}

              <Grid size={{ xs: 12 }} container sx={{ marginTop: '32px' }}>
                <SubsectionHeader>
                  {t('legalEntity.licenceDetails.history.header')}
                </SubsectionHeader>
              </Grid>
              <DetailsContainerWhite
                container
                spacing={2}
                rowSpacing={2}
                sx={{ marginBottom: '32px' }}
              >
                <Grid size={{ xs: 12 }}>
                  <FormRadioGroup
                    name="historyDisplay"
                    label={t('legalEntity.licenceDetails.history.display.label')}
                    oneLine
                    control={control}
                    errors={errors}
                    options={[
                      {
                        label: t('legalEntity.licenceDetails.history.display.licence.label'),
                        value: ELicenceHistoryDisplay.LICENCE,
                      },
                      ...(hasPermissions([EPermission.PRINT_LICENCE])
                        ? [
                            {
                              label: t(
                                'legalEntity.licenceDetails.history.display.printout.label',
                              ),
                              value: ELicenceHistoryDisplay.PRINTOUT,
                            },
                          ]
                        : []),
                    ]}
                    onChangeOption={(target) =>
                      setHistoryDisplay(
                        (target as HTMLInputElement).value as ELicenceHistoryDisplay,
                      )
                    }
                  />
                </Grid>
                {historyDisplay === ELicenceHistoryDisplay.PRINTOUT ? (
                  <>
                    {historyPrintouts && historyPrintouts.length > 0 ? (
                      <Grid size={{ xs: 12 }} container>
                        {isDesktop ? (
                          <Table
                            columns={printoutHistoryTableColumns(longDateFormat)}
                            dataSource={mapPrintoutsHistoryToDataSource(
                              t,
                              historyPrintouts,
                              weaponLicencePrintType,
                            )}
                          />
                        ) : (
                          <CardList
                            items={mapPrintoutsHistoryToDataSource(
                              t,
                              historyPrintouts,
                              weaponLicencePrintType,
                            )}
                            render={(data) => (
                              <Grid size={{ xs: 12 }} key={data.id}>
                                <PrintoutHistoryTableCard data={data} t={t} />
                              </Grid>
                            )}
                          />
                        )}
                      </Grid>
                    ) : (
                      <Grid size={{ xs: 12 }}>
                        <Typography
                          variant="body2"
                          sx={{ fontStyle: 'italic', color: '#666' }}
                        >
                          {t('legalEntity.licenceDetails.printoutHistory.missing')}
                        </Typography>
                      </Grid>
                    )}
                  </>
                ) : (
                  <>
                    {licenceHistory && licenceHistory.length > 0 ? (
                      <Grid size={{ xs: 12 }} container>
                        {isDesktop ? (
                          <Table
                            columns={historyTableColumns(
                              longDateFormat,
                              weaponLicenceStatus || [],
                              t,
                              handleOpenHistoryDetailsModal,
                              handleShowDetailsModal,
                            )}
                            dataSource={mapHistoryToDataSource(licenceHistory)}
                          />
                        ) : (
                          <CardList
                            items={mapHistoryToDataSource(licenceHistory)}
                            render={(data) => (
                              <Grid size={{ xs: 12 }} key={data.id}>
                                <HistoryTableCard
                                  data={data}
                                  weaponLicenceStatus={weaponLicenceStatus || []}
                                  t={t}
                                  handleOpenHistoryDetailsModal={handleOpenHistoryDetailsModal}
                                  showDetails={handleShowDetailsModal}
                                />
                              </Grid>
                            )}
                          />
                        )}
                      </Grid>
                    ) : (
                      <Grid size={{ xs: 12 }}>
                        <Typography
                          variant="body2"
                          sx={{ fontStyle: 'italic', color: '#666' }}
                        >
                          {t('legalEntity.licenceDetails.history.missing')}
                        </Typography>
                      </Grid>
                    )}
                  </>
                )}
              </DetailsContainerWhite>
            </Grid>
          </div>
        )
      )}

      <LicenceActionModal
        open={isPrintLicenceModalOpen}
        name={t('printLicence.modal.button.label')}
        title={t('printLicence.modal.title')}
        message={t('printLicence.modal.message.text')}
        cancelButtonLabel={t('general.no.label')}
        approveButtonLabel={t('general.yes.label')}
        onClickApprove={async () => {
          if (licenceId) {
            const res = await handleEnqueueLicencePrint();
            if (res) {
              await getLegalEntityLicenceDetailsData(licenceId);
            }
          }
          setIsPrintLicenceModalOpen(false);
        }}
        onClickClose={() => setIsPrintLicenceModalOpen(false)}
      />

      <LicenceActionModal
        open={isRevokeModalOpen}
        areYouSureModal
        name={t('revokeLicence.modal.button.label')}
        title={t('revokeLicence.modal.title')}
        message={t('revokeLicence.modal.message.text')}
        approveButtonLabel={t('revokeLicence.modal.button.label')}
        approveButtonVariant={EAlertVariants.error}
        showDualReasonFields
        onClickApprove={async (internalReason?: string, externalReason?: string) => {
          if (licenceId && internalReason && externalReason) {
            const success = await handleRevokeWeaponLicence(licenceId, {
              internalReason,
              externalReason,
            });
            if (success) {
              setIsRevokeModalOpen(false);
              await getLegalEntityLicenceDetailsData(licenceId);
              await getLicenceHistoryData(licenceId);
            }
          }
        }}
        onClickClose={() => setIsRevokeModalOpen(false)}
      />

      <LicenceActionModal
        open={isSuspendModalOpen}
        areYouSureModal
        name={t('suspendLicence.modal.button.label')}
        title={t('suspendLicence.modal.title')}
        message={t('suspendLicence.modal.message.text')}
        approveButtonLabel={t('suspendLicence.modal.button.label')}
        approveButtonVariant={EAlertVariants.error}
        showDualReasonFields
        onClickApprove={async (internalReason?: string, externalReason?: string) => {
          if (licenceId && internalReason && externalReason) {
            const success = await handleSuspendWeaponLicence(licenceId, {
              internalReason,
              externalReason,
            });
            if (success) {
              setIsSuspendModalOpen(false);
              await getLegalEntityLicenceDetailsData(licenceId);
              await getLicenceHistoryData(licenceId);
            }
          }
        }}
        onClickClose={() => setIsSuspendModalOpen(false)}
      />

      <LicenceActionModal
        open={isSurrenderModalOpen}
        areYouSureModal
        name={t('surrenderLicence.modal.button.label')}
        title={t('surrenderLicence.modal.title')}
        message={t('surrenderLicence.modal.message.text')}
        approveButtonLabel={t('surrenderLicence.modal.button.label')}
        approveButtonVariant={EAlertVariants.error}
        showDualReasonFields
        onClickApprove={async (internalReason?: string, externalReason?: string) => {
          if (licenceId && internalReason && externalReason) {
            const success = await handleSurrenderWeaponLicence(licenceId, {
              internalReason,
              externalReason,
            });
            if (success) {
              setIsSurrenderModalOpen(false);
              await getLegalEntityLicenceDetailsData(licenceId);
              await getLicenceHistoryData(licenceId);
            }
          }
        }}
        onClickClose={() => setIsSurrenderModalOpen(false)}
      />

      <LicenceActionModal
        open={isReactivateModalOpen}
        areYouSureModal
        name={t('reactivateLicence.modal.button.label')}
        title={t('reactivateLicence.modal.title')}
        message={t('reactivateLicence.modal.message.text')}
        approveButtonLabel={t('reactivateLicence.modal.button.approve.label')}
        showDualReasonFields
        onClickApprove={async (internalReason?: string, externalReason?: string) => {
          if (licenceId && internalReason && externalReason) {
            const actionResult = await handleReactivateWeaponLicence(licenceId, {
              internalReason,
              externalReason,
            });

            if (actionResult) {
              setIsReactivateModalOpen(false);
              await getLegalEntityLicenceDetailsData(licenceId);
              await getLicenceHistoryData(licenceId);
            }
          }
        }}
        onClickClose={() => setIsReactivateModalOpen(false)}
      />

      <LicenceActionModal
        open={isCancelModalOpen}
        areYouSureModal
        name={t('cancelLicence.modal.button.label')}
        title={t('cancelLicence.modal.title')}
        message={t('cancelLicence.modal.message.text')}
        approveButtonLabel={t('cancelLicence.modal.button.submit.label')}
        showDualReasonFields
        onClickApprove={async (internalReason?: string, externalReason?: string) => {
          if (licenceId && internalReason && externalReason) {
            const success = await handleCancelWeaponLicence(licenceId, {
              internalReason,
              externalReason,
            });
            if (success) {
              setIsCancelModalOpen(false);
              await getLegalEntityLicenceDetailsData(licenceId);
              await getLicenceHistoryData(licenceId);
            }
          }
        }}
        onClickClose={() => setIsCancelModalOpen(false)}
      />

      <LicenceActionModal
        open={isRenewModalOpen}
        title={t('renewLicence.modal.title')}
        message={t(getLicenceCaseRenewStatusText(caseRenewalStatus?.status))}
        approveButtonLabel={t('renewLicence.modal.button.approve.label')}
        cancelButtonLabel={t('general.no.label')}
        onClickApprove={async () => {
          if (
            licenceId &&
            (caseRenewalStatus?.status === ECaseRenewalStatus.EXISTS_DENIED ||
              caseRenewalStatus?.status === ECaseRenewalStatus.NOT_EXISTS)
          ) {
            setIsRenewModalOpen(false);
            LicenceStore.clearStore();
            if (isFromLE) {
              navigate(
                `${ERouteLinks.LegalEntityLicenceRenew.replace(':id', id).replace(
                  ':licenceId',
                  licenceId as string,
                )}?type=${
                  type === ELegalEntityTypes.individual
                    ? LEAccordionNames.INDIVIDUAL
                    : LEAccordionNames.ORGANISATION
                }& expand=${expand} `,
              );
            } else {
              navigate(
                `${ERouteLinks.DetailLicenceRenew.replace(
                  ':licenceId',
                  licenceId as string,
                )}?type=${
                  type === ELegalEntityTypes.individual
                    ? LEAccordionNames.INDIVIDUAL
                    : LEAccordionNames.ORGANISATION
                } `,
              );
            }
          } else if (caseRenewalStatus?.caseUniqueId) {
            isFromLE
              ? navigate(
                  `${ERouteLinks.LegalEntityCasesDetailsPage.replace(':id', id as string).replace(':caseId', caseRenewalStatus?.caseUniqueId as string)}?type=${
                    type === ELegalEntityTypes.individual
                      ? LEAccordionNames.INDIVIDUAL
                      : LEAccordionNames.ORGANISATION
                  } `,
                )
              : navigate(
                  `${ERouteLinks.CasesDetailsPage.replace(':caseId', caseRenewalStatus?.caseUniqueId as string)} `,
                );
          }
        }}
        onClickClose={() => setIsRenewModalOpen(false)}
      />
      <LicenceActionModal
        open={isVaryModalOpen}
        title={t('varyLicence.modal.title')}
        message={t(getLicenceCaseVaryStatusText(caseVariationStatus?.status))}
        approveButtonLabel={t('renewLicence.modal.button.approve.label')}
        cancelButtonLabel={t('general.no.label')}
        onClickApprove={async () => {
          if (
            licenceId &&
            (caseVariationStatus?.status === ECaseVariationStatus.EXISTS_DENIED ||
              caseVariationStatus?.status === ECaseVariationStatus.NOT_EXISTS)
          ) {
            handleVary();
          } else if (caseVariationStatus?.caseUniqueId) {
            isFromLE
              ? navigate(
                  `${ERouteLinks.LegalEntityCasesDetailsPage.replace(':id', id as string).replace(':caseId', caseVariationStatus?.caseUniqueId as string)}?type=${
                    type === ELegalEntityTypes.individual
                      ? LEAccordionNames.INDIVIDUAL
                      : LEAccordionNames.ORGANISATION
                  } `,
                )
              : navigate(
                  `${ERouteLinks.CasesDetailsPage.replace(':caseId', caseVariationStatus?.caseUniqueId as string)} `,
                );
          }
        }}
        onClickClose={() => setIsVaryModalOpen(false)}
      />

      <LicenceHistoryDetailsModal
        open={isHistoryDetailsModalOpen}
        historyDetailsData={historyDetailsData}
        onClose={handleCloseHistoryDetailsModal}
      />
      <FormModal
        open={showDetailsModalOpen && !!detailsReasonModal}
        onClickClose={() => {
          setShowDetailsModalOpen(false);
          setDetailsReasonModal(null);
        }}
        title={t(detailsReasonModal?.title ?? '')}
        titleLeft
        cancelButtonLabel={t('general.close.label')}
      >
        <Grid sx={{ gap: 2.5, mb: '10px', mt: '20px' }}>
          <Grid sx={{ gap: 0.5 }}>
            <Typography variant="subtitle2">
              {t('licenceActionModal.internalReason.label')}
            </Typography>
            <Typography variant="body2">{detailsReasonModal?.internalReason}</Typography>
          </Grid>
          <Grid sx={{ gap: 0.5 }}>
            <Typography variant="subtitle2">
              {t('licenceActionModal.externalReason.label')}
            </Typography>
            <Typography variant="body2">{detailsReasonModal?.externalReason}</Typography>
          </Grid>
        </Grid>
      </FormModal>
    </>
  );
};

export { LegalEntityViewLicencePage };
